import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { AdminImportNavBar } from "@/components/AdminImportNavBar"
import { useOutletContext } from "react-router-dom";


const AdminImportLayout = () => {
    const parentContext = useOutletContext();
    const [, setPageTitle] = parentContext
    
    useEffect(() => {
        setPageTitle("Imports / Exports")
    }, [])

    return (
        <>
            <AdminImportNavBar />
            <Outlet context={parentContext} />
        </>
    )
}

export default AdminImportLayout;